import { render, staticRenderFns } from "./SmallDashDisplay.vue?vue&type=template&id=673d1442&scoped=true&"
import script from "./SmallDashDisplay.vue?vue&type=script&lang=ts&"
export * from "./SmallDashDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SmallDashDisplay.vue?vue&type=style&index=0&id=673d1442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d1442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
